import { Dialog, Button } from "@mui/material";
import { useTheme } from "../../../../components/hooks/useTheme";
import colorConfigs from "../../../../configs/colorConfigs";
import moment from "moment";
import useGeneral from "../../../../components/hooks/useGeneral";

type Props = {
    editPopup: boolean;
    hidePopup: () => void;
    particularTransactionDetails: any;
}

export default function TransactionInfo({ editPopup, hidePopup, particularTransactionDetails }: Props) {
    const { themeStyles } = useTheme();
    const { dateFormat }: any = useGeneral();

    return (
        <>
            <Dialog
                open={editPopup}
                sx={{
                    '& .MuiDialog-paper': {
                        maxWidth: '800px',
                        width: '100%',
                        borderRadius: '16px',
                    },
                }}
            >
                <div className={`px-[24px] py-[10px] h-full ${themeStyles.main.tailwindSectionBg}`}>
                    <div className={`w-full bg-transparent rounded-lg p-[10px] flex flex-col gap-2.51`}>
                        <div className="w-full mt-2">
                            <div className={`w-full`}>
                                <div className={`sticky top-0 z-10 flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor} ${themeStyles.main.tailwindSectionBg}`}>
                                    <div className="flex items-center gap-1.5">
                                        <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Transaction Info</h2>
                                    </div>

                                    <button
                                        onClick={hidePopup}
                                        className="absolute right-2 top-2 text-gray-500 hover:text-red-500 transition"
                                    >
                                        <span className="material-symbols-outlined text-[20px]">close</span>
                                    </button>
                                </div>

                                <div className="mt-2 p-2">
                                    <div className="w-full">
                                        <div className="grid grid-cols-2 gap-6">
                                            <div className="space-y-4">
                                                <div className="flex flex-col gap-1.5">
                                                    <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Reference</span>
                                                    <span className={`text-sm ${themeStyles.main.textSubHeadingColor}`}>{particularTransactionDetails?.reference}</span>
                                                </div>

                                                <div className="flex flex-col gap-1.5">
                                                    <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Status</span>
                                                    <span className={`text-sm ${themeStyles.main.textSubHeadingColor}`}>{particularTransactionDetails?.status}</span>
                                                </div>

                                                <div className="flex flex-col gap-1.5">
                                                    <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Item</span>
                                                    <span className={`text-sm ${themeStyles.main.textSubHeadingColor}`}>{particularTransactionDetails?.item}</span>
                                                </div>

                                                <div className="flex flex-col gap-1.5">
                                                    <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Gateway</span>
                                                    <span className={`text-sm ${themeStyles.main.textSubHeadingColor}`}>{particularTransactionDetails?.gateway}</span>
                                                </div>

                                                <div className="flex flex-col gap-1.5">
                                                    <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Description</span>
                                                    <span className={`text-sm ${themeStyles.main.textSubHeadingColor}`}>{particularTransactionDetails?.description}</span>
                                                </div>

                                                <div className="flex flex-col gap-1.5">
                                                    <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Created At</span>
                                                    <span className={`text-sm ${themeStyles.main.textSubHeadingColor}`}>{particularTransactionDetails?.createdAt
                                                        ? moment(new Date(particularTransactionDetails.createdAt)).format(dateFormat + " hh:mm a")
                                                        : ""}</span>
                                                </div>

                                                <div className="flex flex-col gap-1.5">
                                                    <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Authorization Charged?</span>
                                                    <span className={`text-sm ${themeStyles.main.textSubHeadingColor}`}>{particularTransactionDetails?.authorizationCharged ? "Yes" : "No"}</span>
                                                </div>

                                                <div className="flex flex-col gap-1.5">
                                                    <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>UUID</span>
                                                    <span className={`text-sm ${themeStyles.main.textSubHeadingColor}`}>{particularTransactionDetails?.uuid}</span>
                                                </div>
                                            </div>

                                            <div className="space-y-4">
                                                <div className="flex flex-col gap-1.5">
                                                    <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Contact</span>
                                                    <span className={`text-sm ${themeStyles.main.textSubHeadingColor}`}>{particularTransactionDetails?.contact}</span>
                                                </div>

                                                <div className="flex flex-col gap-1.5">
                                                    <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Amount</span>
                                                    <span className={`text-sm ${themeStyles.main.textSubHeadingColor}`}>{particularTransactionDetails?.amount}</span>
                                                </div>

                                                <div className="flex flex-col gap-1.5">
                                                    <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Refunded Amount</span>
                                                    <span className={`text-sm ${themeStyles.main.textSubHeadingColor}`}>{particularTransactionDetails?.refundedAmount}</span>
                                                </div>

                                                <div className="flex flex-col gap-1.5">
                                                    <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Status Description</span>
                                                    <span className={`text-sm ${themeStyles.main.textSubHeadingColor}`}>{particularTransactionDetails?.statusDescription}</span>
                                                </div>

                                                <div className="flex flex-col gap-1.5">
                                                    <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Charged At</span>
                                                    <span className={`text-sm ${themeStyles.main.textSubHeadingColor}`}> {particularTransactionDetails?.chargedAt
                                                        ? moment(new Date(particularTransactionDetails.chargedAt)).format(dateFormat + " hh:mm a")
                                                        : ""}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="flex items-center gap-1.5 mt-5">
                                            <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Credit Card Details</h2>
                                        </div>
                                        <hr />

                                        <div className="grid grid-cols-2 gap-6 mt-4">
                                            <div className="space-y-4">
                                                <div className="flex flex-col gap-1.5">
                                                    <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Cardholder's Name</span>
                                                    <span className={`text-sm ${themeStyles.main.textSubHeadingColor}`}>{particularTransactionDetails?.cardholderName}</span>
                                                </div>

                                                <div className="flex flex-col gap-1.5">
                                                    <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Last 4 Digits</span>
                                                    <span className={`text-sm ${themeStyles.main.textSubHeadingColor}`}>....{particularTransactionDetails?.last4Digits}</span>
                                                </div>
                                            </div>

                                            <div className="space-y-4">
                                                <div className="flex flex-col gap-1.5">
                                                    <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Brand</span>
                                                    <span className={`text-sm ${themeStyles.main.textSubHeadingColor}`}>{particularTransactionDetails?.brand}</span>
                                                </div>

                                                <div className="flex flex-col gap-1.5">
                                                    <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Zip Code</span>
                                                    <span className={`text-sm ${themeStyles.main.textSubHeadingColor}`}>{particularTransactionDetails?.zipCode}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div className={`sticky bottom-0 flex justify-start gap-4 p-4 ${themeStyles.main.tailwindSectionBg} z-10`}>
                                            <Button
                                                variant="contained"
                                                sx={{
                                                    backgroundColor: colorConfigs.btn.cancel.bg,
                                                    border: colorConfigs.btn.cancel.border,
                                                    color: colorConfigs.btn.cancel.color
                                                }}
                                                onClick={hidePopup}
                                            >
                                                Close
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
        </>
    )
}